import React from 'react';
import PageTemplate from '../../../components/template/PageTemplate';
import { CS_REVIEW_PAGE_NAME } from '../../../constants/service/app/csReviewConstants';
import CsReviewDetailWrap from '../../../views/cs/review/detail/CsReviewDetailWrap';

const CsReviewDetail = () => {
  return (
    <PageTemplate pageName={CS_REVIEW_PAGE_NAME.REVIEW_DETAIL}>
      <CsReviewDetailWrap />
    </PageTemplate>
  );
};

export default CsReviewDetail;
